import styled, { css } from 'styled-components'
import LiveCardContainer from 'live/components/ui/CardContainer'

export const CardContainer = styled(LiveCardContainer)`
    width: 100%;
    padding: unset;
    position: unset;

    header {
        z-index: 3;
        height: 54px;
        display: flex;
        padding: 18px;
        align-items: center;
        box-shadow: 0px 3px 4px -3px rgba(54, 65, 89, 0.2);
        > div {
            font-size: 16px !important;
        }
        user-select: none;
    }
`
